import React, { useEffect, useState } from "react";
import * as httpService from '../../services/HTTPService';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import ProductCarousel from "./product-carousel";
import LightGalleryCarousel from "./lightGalleryCarousel";
import SwiperSlider from "./SwiperSlider";
import SlickCarousel from "../slick-carousel";
import { useTranslation } from 'react-i18next';
import BrandButton from "../brand-button";
import { TransformWrapper, TransformComponent, useControls } from "react-zoom-pan-pinch";
import { addToBasket } from "../../utils/utils";
import { ToastContainer, toast } from 'react-toastify';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CustomNotification from "../custom-notification";
const LazyProductImgComp = React.lazy(() => import("./product-img-comp"));

const ProductComponent = (props: any) => {
    const { t, i18n } = useTranslation();  
    const publicUrl = process.env.PUBLIC_URL;
    const defaultImg = publicUrl + "/img/no-photo.png";
    const orderSampleLbl = i18n.exists("pages.orderSample") ? t('pages.orderSample') : "Поръчай мостра";
    const addToBoardLbl = i18n.exists("pages.addToBoard") ? t('pages.addToBoard') : "Добави в борда";
    const [colorArr, setColorArr] = useState([]);
    const toastId: any = React.useRef(null)
    const addedItemWarning = i18n.exists("pages.addedItemWarning") ? t('pages.addedItemWarning') : "Тази мостра вече е добавена.";        
    const addedItemSuccess = i18n.exists("pages.addedItemSuccess") ? t('pages.addedItemSuccess') : "Мострата е добавена успешно.";
    const closeLbl = i18n.exists("pages.closeLbl") ? t('pages.closeLbl') : "Затвори";
    const chooseBoardLbl = i18n.exists("pages.chooseBoard") ? t('pages.chooseBoard') : "Избери борд";
    const saveChangesdLbl = i18n.exists("pages.saveChangesLbl") ? t('pages.saveChangesLbl') : "Запази";
    const [moodboards, setMoodboards] = useState([]);
    const user: any = localStorage.getItem('auth-user');
    const authUser = JSON.parse(user);
    const email = authUser && authUser.email ? authUser.email : "";
    const [show, setShow] = useState(false);
    const[disabledBtn, setDisableDBtn] = useState(true);
    const handleClose = () => {
        setShow(false);
        setDisableDBtn(true);
        const name: any = document.querySelector(".selected") ? document.querySelector(".selected")?.innerHTML : "";
        setMoodboardName(name);
        moodboardName = name;
    };
    const handleShow = () => setShow(true);
    const [boardId, setBoardId] = useState('');
    let [moodboardName, setMoodboardName] = useState("");
    const msgAddToBoardLbl = i18n.exists("pages.msgAddToBoard") ? t('pages.msgAddToBoard') : "Материалът беше добавен в moodboard: (име)";
    const seeItLbl = i18n.exists("pages.seeItLbl") ? t('pages.seeItLbl') : "Желаете ли да го разгледате?";
    const yesLbl = i18n.exists("pages.yesLbl") ? t('pages.yesLbl') : "Да";
    const noLbl = i18n.exists("pages.noLbl") ? t('pages.noLbl') : "Не";
    
    const tempArray = [
        `${publicUrl}/img/grid/product-image.jpg`, 
        `${publicUrl}/img/grid/product-image2.jpg`, 
        `${publicUrl}/img/grid/product-image.jpg`, 
        `${publicUrl}/img/grid/product-image2.jpg`,
        `${publicUrl}/img/grid/product-image.jpg`, 
        `${publicUrl}/img/grid/product-image2.jpg`
    ]
    const defaultProduct = {
        "id": 1,
        "name": "",
        "manufacturer": "",
        "collection": "",
        "reference": "",
        "composition": "41% Полиетилен 37% Полиакрил 22% Полиестер",
        "width": "132 См",
        "linkDirection": "Направо",
        "horizontalRepeat": "33,0 См",
        "verticalRepeat": "30,0 См",
        "weight": "600 Gr/ML",
        "martindale": "40 000 TRS",
        "care": "🧼 📺",
        "usage": "🌟",
        "specialFeatures": "",
        "color": "Розов",
        "description": "Описание на продукт 1.",
        "imageUrl": "",
        //"images": tempArray,
        "images": []
    }
    const [product, setProduct] = useState(defaultProduct);
    const prImageUrl = product.imageUrl ? product.imageUrl : `${publicUrl}/img/grid/product-image.jpg`;
    const imageArray = [
        {src: prImageUrl, id: 1, alt: "slider image"},
        {src: `${publicUrl}/img/grid/product-image2.jpg`, id: 2, alt: "slider image"},
        {src: `${publicUrl}/img/grid/product-image.jpg`, id: 3, alt: "slider image"},
        {src: `${publicUrl}/img/grid/product-image2.jpg`, id: 4, alt: "slider image"},
        {src: `${publicUrl}/img/grid/product-image.jpg`, id: 5, alt: "slider image"}    
    ];

    const Controls = () => {
        const { zoomIn, zoomOut } = useControls();
      
        return (
          <div className="tools">
            <button onClick={() => zoomIn()}>+</button>
            <button onClick={() => zoomOut()}>-</button>
          </div>
        );
      };

      const Message = () => {
        const msg = msgAddToBoardLbl + " " + "<strong> " + moodboardName +" </strong>" + seeItLbl;
        return (
            <CustomNotification message={msg}></CustomNotification>
        )
    }

      const download = async (imgUrl: string) => {
        const originalImage = imgUrl;
        const image = await fetch(originalImage);
    
        // Split image name
        const nameSplit = originalImage.split("/");
        const  duplicateName = nameSplit.pop();
    
        const imageBlog = await image.blob()
        const imageURL = URL.createObjectURL(imageBlog)
        const link = document.createElement('a')
        link.href = imageURL;
        link.download = "" + duplicateName + "";
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    };

    const orderSampleOnclick = (e: any) => {
        const orderObj = {
            name: product.name,
            id: product.id,
            imageUrl: product.imageUrl
        }
        e.preventDefault();
        addToBasket(orderObj, toastId, addedItemWarning, addedItemSuccess);
        //console.log(orderObj)
    }

    const addToBoardOnclick = (e: any) => {
        e.preventDefault();
        handleShow();
    }

    const getMoodboards = () => {
        if(email && email !== "") {
            httpService.getAllMoodboards(email).then((res) => {
                if(res) {
                    setMoodboards(res.data);
                }
            })
            .catch ((err) => console.log(err))
        }
    }

    const setMoodBoardId = (e: any, moodboard: any) => {
        //setMoodboardName(moodboard.name);
        //moodboardName = moodboard.name;
        document.querySelector(".selected")?.classList.remove("selected");
        e.target.classList.add("selected");
       //setBoardId(moodboardId);
        //setDisableDBtn(false);
    }

    const MoodBoardList = React.memo((props: any) => {
        //console.log(moodBoards)
        if(moodboards && moodboards.length > 0) {
            return (
                <div className="moodb-list">
                    <ul>
                        {moodboards.map((item: any, i: any) => {
                            return(
                                <li id={item.id} className="moodb-list-item" key={i} onClick={(e) => setMoodBoardId(e, item)}>{item.name}</li>
                            )
                        })}
                    </ul>
                </div>
            )
        }
        return null;
    })

    const CloseButton = ({ closeToast }: any) => (
        <div className="flex-box buttons-toast" style={{"justifyContent": "end", "gap": "20px"}}>
            <a href="/moodboard">{yesLbl}</a>
            <span onClick={closeToast}>{noLbl}</span>
        </div>
    );

    const handleAddToBoard = () => {
        const bId = boardId && boardId !== "" ? boardId : document.querySelector(".selected")?.getAttribute("id");
        if(bId && bId !== "") {
            const body = {
                productId: product.id
            }
            httpService.addProductToMoodboard(body, bId).then((res) => {
                if(res) {
                    toast(Message, {
                        hideProgressBar: true,
                        autoClose: false,
                        position: "top-center",
                        className: "custom-toast"
                    });
                    //toast.success(addedItemSuccess);
                    handleClose();
                }
            })
            .catch((err) => {
                console.log(err) 
                toast.warn(addedItemWarning);
            })
        }
    }

    const Dialog = React.memo(() => {
        return (
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>{chooseBoardLbl}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <MoodBoardList />
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {closeLbl}
                </Button>
                <Button variant="primary" onClick={handleAddToBoard}>
                   {saveChangesdLbl}
                </Button>
                </Modal.Footer>
            </Modal>
        )
    });
    
    useEffect(() => {
        if(props.productId) {
            httpService.getProductById(props.productId).then((res: any) => {
                if(res) {
                    //console.log(res);
                    setProduct(res.data);
                    if(res.data.color && res.data.color !== "") {
                        const colors = res.data.color.split(',');
                        setColorArr(colors);
                    }
                }
            })
            .catch((err) => console.log(err))
        }
        getMoodboards();
    }, [])

    return (
        <>
        <Dialog />
        {product.name && product.name !== "" ? (
            <div className="product-component">
                <ToastContainer position="top-center" limit={1} closeButton={CloseButton} />
                
                <Row className="mb-3">
                    <Col md="6">
                        <h2 className="product-title">{product.name}</h2>
                        <div className="product-gallery">
                            {product.images && product.images.length > 0 ? (
                                <SlickCarousel sliderSource={imageArray} />
                            ) : (
                                <div key={product.id}>
                                    <div className="img-body">
                                        <span onClick={() => download(product.imageUrl)} className="download"></span>
                                        <TransformWrapper
                                            initialScale={1}
                                            >
                                            {({ zoomIn, zoomOut, ...rest }) => (
                                                <>
                                                <Controls />
                                                <TransformComponent>
                                                    {/* <img src={product.imageUrl} alt={"slider image"} /> */}
                                                    <LazyProductImgComp imageUrl={product.imageUrl} />
                                                </TransformComponent>
                                                </>
                                            )}
                                        </TransformWrapper>
                                    </div>
                                </div>
                            )}
                            
                            {product.description && product.description !== "x"? (
                                <div className="product-desc">
                                    <p>{product.description}</p>
                                </div>
                            ) : null}
                            {/* <SwiperSlider />
                            <LightGalleryCarousel />
                            <ProductCarousel imgArray={product['images']} /> */}
                        </div>
                        {/* <img src={product.imageUrl && product.imageUrl !== "" ? product.imageUrl : defaultImg} alt="Product image" className="img-responsive" /> */}
                    </Col>
                    <Col md="6">
                        <div className="features">
                            <ul>
                                <li><span>{i18n.exists("product.collection") ? t('product.collection') : "Колекция"}: </span><strong>{product.collection}</strong></li>
                                <li><span>{i18n.exists("product.manufacturer") ? t('product.manufacturer') : "Марка"}: </span><span>{product.manufacturer}</span></li>
                                <li><span>{i18n.exists("product.reference") ? t('product.reference') : "Справка"}: </span><span>{product.reference}</span></li>
                                <li><span>{i18n.exists("product.composition") ? t('product.composition') : "Състав"}: </span><span>{product.composition}</span></li>
                                <li><span>{i18n.exists("product.width") ? t('product.width') : "Ширина"}: </span><span>{product.width}</span></li>
                                <li><span>{i18n.exists("product.linkDirection") ? t('product.linkDirection') : "Индикация за връзка"}: </span><span>{product.linkDirection}</span></li>
                                <li><span>{i18n.exists("product.horizontalRepeat") ? t('product.horizontalRepeat') : "Хоризонтално повторение"}: </span><span>{product.horizontalRepeat}</span></li>
                                <li><span>{i18n.exists("product.verticalRepeat") ? t('product.verticalRepeat') : "Вертикално повторение"}: </span><span>{product.verticalRepeat}</span></li>
                                <li><span>{i18n.exists("product.weight") ? t('product.weight') : "Тегло"}: </span><span>{product.weight}</span></li>
                                <li><span>{i18n.exists("product.martindale") ? t('product.martindale') : "Мартиндейл тест за триене"}: </span><span>{product.martindale}</span></li>
                                <li><span>{i18n.exists("product.care") ? t('product.care') : "Поддръжка"}: </span><span>{product.care}</span></li>
                                <li><span>{i18n.exists("product.usage") ? t('product.usage') : "Употреба"}: </span><span>{product.usage}</span></li>
                                <li><span>{i18n.exists("product.specialFeatures") ? t('product.specialFeatures') : "Специални характеристики"}: </span><span>{product.specialFeatures}</span></li>
                            </ul>
                            <div className="features-warn-msg">
                                <p>
                                    {i18n.exists("product.featuresWarnMsg") ? t('product.featuresWarnMsg') : "Моля, имайте предвид, че компютърните екрани могат да причинят вариации в предаването на цветовете и че ширината и размерите за повторение са приблизителни."}
                                </p>
                                <div className="flex-box" style={{"gap" : "30px", "justifyContent" : "center"}} >
                                    <BrandButton 
                                        text={orderSampleLbl} 
                                        title={orderSampleLbl} 
                                        onClick={orderSampleOnclick} 
                                        backgroundColor="#fff"
                                        classNameAttr="capitalize" 
                                    />

                                    <BrandButton 
                                        text={addToBoardLbl} 
                                        title={addToBoardLbl} 
                                        onClick={addToBoardOnclick} 
                                        backgroundColor="#fff"
                                        classNameAttr="capitalize" 
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <div className="color-list">
                        <h3 className="inter-thin">{i18n.exists("product.availableColors") ? t('product.availableColors') : "Налични други цветове"}</h3>
                       {colorArr.length > 0 ? (
                        <div>
                            {colorArr.map((color: any, index: any) => {
                                return (
                                    <div className="bl-chip" key={index} >{color}</div>
                                )
                            })}
                        </div>
                       ) : null}
                        {/* <ul>
                            {tempArray.map((img: any, index: number) => {
                                return (
                                    <li key={index} className="rounded"><img src={img} alt="color image" className="img-responsive rounded" /></li>
                                )
                            })}
                        </ul> */}
                </div>
                <div className="align-center" style={{'marginBottom': '50px'}}>
                    <BrandButton 
                        isNavigateBtn={true}
                        text={i18n.exists("product.backToCatalog") ? t('product.backToCatalog') : "Върни се към каталога"} 
                        href="/" 
                        title={i18n.exists("product.backToCatalog") ? t('product.backToCatalog') : "Върни се към каталога"} 
                        backgroundColor="#fff"
                        classNameAttr="capitalize"
                    />
                </div>
            </div>
        ) : null}
        </>
    )
}

export default ProductComponent;